import { render } from "./sdgdcgbdDetail.vue?vue&type=template&id=20522d48&scoped=true&ts=true"
import script from "./sdgdcgbdDetail.vue?vue&type=script&lang=ts"
export * from "./sdgdcgbdDetail.vue?vue&type=script&lang=ts"

import "./sdgdcgbdDetail.vue?vue&type=style&index=0&id=20522d48&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20522d48"]])

export default __exports__